<template>
  <div class="box">
    <div class="modulelist6_box" v-if="clientWidth > 768">
      <div class="modulelist6" v-for="(item, index) in list" :key="index">
        <div class="modulelist6_img"><img :src="item.img" alt="" /></div>
        <div class="line6"></div>
        <div class="modulelist6_content">
          <div class="modulelist6_left">
            <span>{{ item.title }}</span>
            <span v-html="item.text"></span>
          </div>
          <div class="modulelist6_right" @click="handleVisit(item)">
            <span>点击访问</span>
            <img
              src="https://staticdn.ht-s.cn/se/ciif/2022/index/icon_next.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <swiper
      :options="swiperOption_m"
      v-else
      ref="mySwiper"
      :auto-play="true"
      class="modulelist6_box"
    >
      <div
        v-if="clientWidth < 768"
        class="swiper-button-prev s-prev"
        slot="button-prev"
      ></div>
      <div
        v-if="clientWidth < 768"
        class="swiper-button-next s-next"
        slot="button-next"
      ></div>
      <swiper-slide v-for="item in list" :key="item.title" class="modulelist6">
        <div class="modulelist6_img"><img :src="item.img" alt="" /></div>
        <div class="line6"></div>
        <div class="modulelist6_content">
          <div class="modulelist6_left">
            <span>{{ item.title }}</span>
            <span v-html="item.text"></span>
          </div>
          <div class="modulelist6_right">
            <span @click="handleVisit(item)">点击访问</span>
            <img
              src="https://staticdn.ht-s.cn/se/ciif/2022/index/icon_next.png"
              alt=""
              @click="handleVisit(item)"
            />
          </div>
        </div>
      </swiper-slide>
      <!-- 指示点 -->
      <!-- <div class="swiper-pagination fx2" slot="pagination"></div> -->
    </swiper>
    <div v-if="clientWidth < 768" class="intronumber">
      <!-- <img src="" alt=""> -->
      <div class="left"></div>
      <span>{{ currentIndex }}/{{ list.length }}</span>
      <div class="right"></div>
    </div>
    <Rdialog :isRegister="isRegister" :isIntegral="isIntegral" :integralText="integralText" @handleClose="handleClose"></Rdialog>
  </div>
</template>

<script>
// import { Swiper, SwiperSlide } from "vue-awesome-swiper";
// import 'swiper/swiper-bundle.min.css';
import { AddPoints } from "@/api/index.js";
import {
  Swiper as SwiperClass,
  Pagination,
  Mousewheel,
  Autoplay,
  Navigation,
  EffectFade,
} from "swiper/core";
import getAwesomeSwiper from "vue-awesome-swiper/dist/exporter";
import "swiper/swiper-bundle.min.css";
import Rdialog from "@/components/rdialog/index.vue";
const { Swiper, SwiperSlide } = getAwesomeSwiper(SwiperClass);
SwiperClass.use([Pagination, Mousewheel, Autoplay, Navigation, EffectFade]);

export default {
  props: {
    list: {
      type: Array,
      value: [],
    },
  },
  components: {
    Swiper,
    SwiperSlide,
    Rdialog,
  },
  data() {
    const that = this;
    return {
      currentIndex: 1,
      swiperOption_m: {
        direction: "horizontal",
        autoplay: {
          delay: 4000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        // loop: true,
        slidesPerView: 1.25,
        centeredSlides: true,
        spaceBetween: 20,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        // pagination: {
        //   el: ".swiper-pagination",
        //   clickable: true,
        //   type: "bullets",
        // },
        on: {
          slideChange: (swiper) => {
            that.currentIndex = swiper.realIndex + 1;
          },
        },
      },
      isRegister: false,
      isIntegral: false,
      integralText: ""
    };
  },
  methods: {
    handleVisit(item) {
      const obj = {
        event: "trk",
        ec: "showroom",
        ea: "click",
        el: "click",
      };
      dataLayer.push(JSON.parse(JSON.stringify(obj)));
      if (this.$store.state.islogin) {
        AddPoints({
          visitType: 202,
          name: item.title,
          track: this.$route.query.track ? this.$route.query.track : "7756",
        }).then((res) => {
          if (res.Status === 1) {
            if (res.Data === "1") {
              this.isIntegral = true;
              this.integralText = res.Message;
            }
          }
        });
        this.$emit("Visitlink", item.link);
      } else {
        this.isRegister = true;
      }
    },
    handleClose() {
      this.isRegister = false;
      this.isIntegral = false
    },
  },
  computed: {
    clientWidth() {
      return this.$store.state.clientWidth;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>